export default __webpack_public_path__ + "static/media/cs.84d59cce.md";